import {formData} from 'methods/utils';

function FaqsPagination($element, options = {}) {
    this.$element = $element;
    this.options = options;

    this.$element.addEventListener('click', this._onClickEvent.bind(this));
}

FaqsPagination.prototype._onClickEvent = function(e) {
    if (this.$element.classList.contains('is-loading')) {
        return false;
    }
    this.$element.classList.add('is-loading');

    const url         = this.$element.dataset.href;
    const page        = this.$element.dataset.page;
    const activeTabId = this.$element.dataset.tabId;
    const $activeTab = document.querySelector(`.js-faq-articles-block[data-tab-id="${activeTabId}"]`);

    fetch(url, {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData({
            page,
        }),
    })
    .then(response => response.json())
    .then(response => {
        if (response.status !== 'ok') {
            throw response;
        }
        return response;
    })
    .then(data => {
        if (!data.tabs[activeTabId - 1].can_load_more) {
            this.$element.remove();
        }
        $activeTab.insertAdjacentHTML('beforeend', data.tabs[activeTabId - 1].questions_without_image_list);
        this.$element.dataset.page = data.tabs[activeTabId - 1].next_page;
    })
    .finally(() => {
        this.$element.classList.remove('is-loading');
    });
}

export default FaqsPagination;
